import type { SVGProps } from 'react';

interface InstagramIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const InstagramIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & InstagramIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 25 25"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <rect fill="#4FA9FF" height={25} rx={12.5} width={25} />
    <g clipPath="url(#instagram_svg__a)">
      <path
        d="M12.5 11.26q-.601 0-1.12.301-.518.3-.819.82a2.2 2.2 0 0 0-.3 1.12q0 .6.3 1.12.3.517.82.818.517.3 1.12.301.6 0 1.12-.3.518-.301.818-.82.3-.517.301-1.12 0-.601-.3-1.12a2.2 2.2 0 0 0-.82-.819 2.2 2.2 0 0 0-1.12-.3m6.72 2.24v-.462q0-1.54-.042-2.31-.027-.881-.266-1.526A3.34 3.34 0 0 0 18.1 7.9a3.34 3.34 0 0 0-1.302-.812q-.657-.237-1.526-.266a46 46 0 0 0-2.31-.042h-.924q-1.539 0-2.31.042-.867.029-1.512.266A3.3 3.3 0 0 0 6.9 7.9a3.34 3.34 0 0 0-.812 1.302q-.237.658-.266 1.526a46 46 0 0 0-.042 2.31v.924q0 1.54.042 2.31.029.869.266 1.512.252.756.812 1.316t1.316.812q.645.239 1.512.266.771.042 2.31.042h.924q1.54 0 2.31-.042.882-.027 1.526-.266A3.34 3.34 0 0 0 18.1 19.1q.56-.56.812-1.316.239-.644.266-1.512.042-.77.042-2.31zm-6.72 3.444a3.4 3.4 0 0 1-1.736-.462 3.4 3.4 0 0 1-1.26-1.253 3.37 3.37 0 0 1-.462-1.729q0-.937.462-1.729a3.47 3.47 0 0 1 1.26-1.26 3.37 3.37 0 0 1 1.736-.469q.938 0 1.73.47.79.468 1.252 1.26.462.79.462 1.728 0 .939-.462 1.73a3.43 3.43 0 0 1-1.253 1.252 3.37 3.37 0 0 1-1.729.462m3.598-6.23a.78.78 0 0 1-.574-.238.77.77 0 0 1-.238-.567q0-.33.238-.567a.77.77 0 0 1 .567-.238q.33 0 .567.238a.77.77 0 0 1 .238.56.8.8 0 0 1-.056.308.6.6 0 0 1-.182.266.9.9 0 0 1-.252.182q-.195.056-.308.056"
        fill="#F8F8F8"
      />
    </g>
    <defs>
      <clipPath id="instagram_svg__a">
        <path d="M5.5 20.5h14v-14h-14z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
